export default {
  googleAnalytics: {
    id: 'UA-75408042-11',
  },
  firebase: {
    apiKey: "AIzaSyCmg_eW5-bD5vfrbC0lFeuK2guzJiZzrj0",
    authDomain: "manitoba-pieces-auto.firebaseapp.com",
    databaseURL: "https://manitoba-pieces-auto.firebaseio.com",
    projectId: "manitoba-pieces-auto",
    storageBucket: "manitoba-pieces-auto.appspot.com",
    messagingSenderId: "1024785891778"
  },
  endDate: new Date(2018, 7, 4, 23, 59, 59), // Fin le 4 août au soir
}



// WEBPACK FOOTER //
// ./src/config.js